import { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import { SERVER_URL } from '../ConstantsEN';
import { PregnancyConception_EndPoint } from '../ConstantsEN';
import { CalculatorsType } from '../ConstantsEN';
import { ConceptionTablev2 } from './Tables';
import { CycleLengthComponent } from './Component';
import SharedHelmet from "../Helmet";
const TITLE = 'Pregnancy Date and Conception Planning Calculator';
const DESCRIPTION = 'The Pregnancy Date and Conception Planning Calculator estimates the expected pregnancy due date based on the expected due date, the date of the last menstrual period, or the date of the ultrasound. The pregnancy date is the day when a person\'s fetus is fertilized. The calculator also estimates a possible range of days when sexual intercourse can lead to fertilization based on the sperm\'s ability to remain inside a woman\'s body for 3 - 5 days.';
const KEYWORDS = 'Pregnancy Date, Conception Planning, Pregnancy Date Calculator';
const OG_URL = 'https://do-calculate.com/calculator/en/pregnancy-conception/';
const apiEndpoint = `${SERVER_URL}/${PregnancyConception_EndPoint}`;
function PregnancyConceptionCalculator() {
    const [firstDayOfLastPeriod, setFirstDate] = useState();
    const [cycleLength, setCyrcleLength] = useState(28);
    const [result, setRestul] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const handleDateChange = (event) => {
        setFirstDate(event.target.value)
    };
    const calculatePregnancyConception = async () => {
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ firstDayOfLastPeriod, cycleLength }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setRestul(data.result);
            } else {
                setRestul(null);
            }
        } catch (error) {
            console.error(error);
        }
    };
    return (
        <div>
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div className="bg-success text-white text-center" style={{ height: '40px', }}><b> Pregnancy Date and Conception Planning Calculator</b></div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                The Pregnancy Date and Conception Planning Calculator estimates the expected pregnancy due date based on the expected due date, the date of the last menstrual period, or the date of the ultrasound. The pregnancy date is the day when a person's fetus is fertilized. The calculator also estimates a possible range of days when sexual intercourse can lead to fertilization based on the sperm's ability to remain inside a woman's body for 3-5 days.
                                <br />
                                <hr />
                            </div>
                            <br />
                        </div>
                        <MobileUnderCalAds/>
                        <div className="row">
                            <div className='col-12 col-md-5 calculatorStyle'>
                                <div className='p-3 mb-2 bg-success text-white'>
                                    Pregnancy Date and Conception Planning Calculator
                                </div>
                                <hr />
                                <br />
                                <div className=" form-group d-flex align-items-center">
                                    <b>  <label className="form-label ms-2" >
                                        <strong>First day</strong> of the last menstrual period
                                    </label>
                                    </b>
                                    <br />
                                    <input
                                        type="date"
                                        id="weightNumber"
                                        value={firstDayOfLastPeriod}
                                        onChange={handleDateChange}
                                        className="form-control ml-2"
                                        style={{ width: '145px' }}
                                        placeholder="175"
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>  <label htmlFor="CycleLength" className="form-label ms-2">
                                        Average time between cycles
                                    </label>
                                    </b>
                                    <CycleLengthComponent handleDateChange={setCyrcleLength} />
                                    <div className="input-group-append">
                                        <span className="input-group-text ">day</span>
                                    </div>
                                </div>
                                <br />
                                <hr />
                                <div>
                                    <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={
                                        calculatePregnancyConception}>Calculate </button>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u> An error occurred:</u></b> Please enter all fields correctly. </div>}
                                {result &&
                                    (
                                        <div>
                                            <h4><div className="p-3 mb-2 bg-success text-white">Results: </div></h4>
                                            <hr />
                                            <ConceptionTablev2 result={result}></ConceptionTablev2>
                                        </div>
                                    )}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.womenCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">Pregnancy Calculator and Planning Description:</div>
                            <div className="info-section-body">
                                <u><b>When Did Conception Occur?</b></u>
                                <br />
                                Many women ask this question when trying to determine the exact day they became pregnant. The fetal age, or age of the fetus, is often calculated from the first day of the mother's last menstrual period. Biologically, fertilization of the egg does not occur until ovulation and egg fertilization, which usually happens at least 10 days after the first day of the mother's last menstrual period.
                                <br/>                                Due to various factors surrounding conception, it is challenging to pinpoint the date of conception accurately. This calculator helps estimate the actual date of conception and a possible range of days when sexual intercourse can lead to conception. There are several methods that can be used to estimate conception dates.
                                <br/>                                <u><b>Last Menstrual Period</b></u>
                                <br />
                                Conception typically occurs between 11-21 days after the first day of the last menstrual period for women with regular cycles. Estimating the date of conception is based on this range but is rarely completely accurate because it is difficult to know precisely when ovulation occurs. Estimating fetal age can be even more challenging for women with irregular cycles or those who don't remember the first day of their last menstrual period. In such cases, one of the most accurate methods to estimate fetal age is through the use of ultrasound.
                                <br/>                                <u><b>Fertilization, Conception, and Pregnancy</b></u>
                                <br />
                                Fertilization and conception are terms often used interchangeably, but this calculator uses definitions preferred by doctors and scientists. Fertilization occurs when a sperm cell and an egg unite in the fallopian tube, forming a fertilized egg, thus initiating the process in which the fetus develops.
                                <br/>                                Conception refers to the process of pregnancy, which scientifically includes both fertilization and the implantation of the fertilized egg into the uterine wall. On a state level (in the United States), there can be some confusion in the use of these terms due to varying definitions. In some cases, a woman is considered pregnant after fertilization, but this does not align with well-established scientific and medical definitions. The long-standing consensus among medical professionals and government policies (in the United States) is that a woman is pregnant when the fertilized egg is implanted in the uterine wall. When this occurs, the woman is said to be "with child." In other words, medically and scientifically, conception involves both fertilization and implantation, and a woman is not considered pregnant until both of these events have taken place.
                                <br/>                                <hr />
                                <b>Last Review Date:</b> 09/07/2023
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default PregnancyConceptionCalculator;
